import React, { useState, useEffect } from "react";

import {
    Box,
    Paper,
    Divider,
    TextField,
    Grid,
    Typography,
    Button,
    IconButton,
    InputAdornment,
    styled,
    Card,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableFooter,
    Chip,
    ListItemText,
    Tab,
    Tabs
} from '@mui/material';

import {
    TabContext,
    TabList,
    TabPanel
} from "@mui/lab";

import { useNavigate, useParams } from "react-router-dom";

import { useDocuments, documentTypes, targetTypes } from "../../../hooks/api/useDocuments";
import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import { useSystemUtils } from "../../../hooks/useSystemUtils";
import { useAppContextFeatures } from "../../../context/AppContext";
import { useSystemRoutes, routeTypes } from "../../../hooks/useSystemRoutes";
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from "../../../hooks/usePermissions";
import {
    getQrCodeDataUrl,
    outputTypes as scanDataOutputTypes,
    scopeTypes as scanDataScopeTypes,
    targetTypes as scanDataTargetTypes
} from "../../../hooks/useScanData";
import { useTranslations } from '../../../hooks/useTranslations';

import { CommonPdf, renderModes, documentTypes as commonPdfDocumentTypes } from "../../common/CommonPdf";
import CommonSectionHeader from "../../common/CommonSectionHeader";
import CommonBreadcumbs from "../../common/CommonBreadcumbs";
import CommonRestricted from "../../common/CommonRestricted";

import DocumentViewFooter from "../ViewDocumentFooter";
import DocumentQrCode from "../DocumentQrCode";
import ViewDocumentDependency from "../ViewDocumentDependency";

import { capitalizeString } from "../../../utils/formatString";

const StyledCard = styled(Card)(({ theme }) => ({
    padding : theme.spacing(3)
}));

const StyledLabel = styled(Typography)(({ theme }) => ({
    fontSize : '0.9rem',
    fontWeight : 800
}))

const StyledContent = styled(Typography)(({ theme }) => ({
    fontSize : '0.9rem'
}))

const StyledContent2 = styled(Typography)(({ theme }) => ({
    fontSize : '0.8rem',
    mt : 2
}))

const StyledDivider = styled(Divider)(({ theme }) => ({
    mt : 1,
    mb : 0,
    borderStyle : 'dashed'
}))

const tabName = {
    document: "Document",
    itemByDocument: "Item By Document",
    pickLocation: "Pick Location"
}

const RenderDocumentTable = ({
    t,
    data
}) => {

    if (!data) return <></>

    return (
        <TableContainer
            // component={Paper}
            sx={{
                // minHeight: 400,
                // maxHeight: 400
            }}
        >
            <Table
                size="small"
                stickyHeader
            >
                <TableHead>
                    <TableRow>
                        <TableCell width={20}>#</TableCell>
                        <TableCell width={150}>{t('documentNo')}</TableCell>
                        <TableCell width={150}>{t('documentDate')}</TableCell>
                        <TableCell width={250}>{t('recipient')}</TableCell>
                        <TableCell width={180}>{t('regions')}</TableCell>
                        {/* <TableCell width={100}>{t('collection')}</TableCell> */}
                        <TableCell align="center" width={100}>{t('qty')}</TableCell>
                        {/* <TableCell align="center" width={100}>{t('completion')}</TableCell> */}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        data?.docs.map((row, index) => {

                            return (
                                <TableRow key={row.id}>
                                    <TableCell>{(index + 1)}</TableCell>
                                    <TableCell>{row?.doc_number}</TableCell>
                                    <TableCell>{row?.doc_date}</TableCell>
                                    <TableCell>
                                        <ListItemText
                                            primary={row?.delivery_profile_name ? capitalizeString({ val : row.delivery_profile_name.toLowerCase() }) : '-'}
                                            secondary={
                                                `
                                                ${row?.delivery_address_1 ? capitalizeString({ val : row?.delivery_address_1.toLowerCase() }) : '-'} 
                                                ${row?.delivery_address_2 ? capitalizeString({ val : row.delivery_address_2.toLowerCase() }) : '-'}
                                                `
                                            }
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <ListItemText
                                            primary={row?.delivery_area ? row.delivery_area : "-"}
                                            secondary={`${row?.delivery_state} ${row?.delivery_country}`}
                                        />
                                    </TableCell>
                                    {/* <TableCell>
                                        <Chip
                                            label={row?.is_collect_payment === "1" ? t('enabled') : t('disabled')}
                                            variant={
                                                row?.is_collect_payment === "1" ? 'contained' : 'outlined'
                                            }
                                            color={"primary"}
                                        />
                                    </TableCell> */}
                                    <TableCell align="center">{row?.doc_ori_qty}</TableCell>
                                    {/* <TableCell align="center">
                                        <Chip
                                            label={row?.is_complete_status === "1" ? t('completed') : t('pending')}
                                            variant={
                                                row?.is_complete_status === "1" ? 'contained' : 'outlined'
                                            }
                                            color={"primary"}
                                        />
                                    </TableCell> */}
                                </TableRow>
                            )
                        })

                    }
                </TableBody>
            </Table>
        </TableContainer>
    )
}

const RenderItemByDocumentTable = ({
    t,
    data
}) => {

    if (!data) return <></>

    return (
        <TableContainer>
            <Table
                size="small"
                stickyHeader
            >
                <TableHead>
                    <TableRow>
                        <TableCell width={20}>#</TableCell>
                        <TableCell width={150}>{t('documentNo')}</TableCell>
                        <TableCell width={300}>{t('recipient')}</TableCell>
                        <TableCell width={120}>{t('code')}</TableCell>
                        <TableCell width={200}>{t('itemName')}</TableCell>
                        <TableCell width={330}>{t('description')}</TableCell>
                        <TableCell align="center" width={140}>{t('qty')}</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {
                        data?.docs.map((i, index) => {
                            return(
                                i.doc_items.map(item => {
                                    return(
                                        <TableRow key={item.item_id}>
                                            <TableCell>{(index + 1)}</TableCell>
                                            <TableCell>{item?.doc_doc_no}</TableCell>
                                            <TableCell>
                                                <ListItemText
                                                    primary={i?.delivery_profile_name ? capitalizeString({ val : i.delivery_profile_name.toLowerCase() }) : '-'}
                                                    secondary={
                                                        `
                                                        ${i?.delivery_address_1 ? capitalizeString({ val : i?.delivery_address_1.toLowerCase() }) : '-'} 
                                                        ${i?.delivery_address_2 ? capitalizeString({ val : i.delivery_address_2.toLowerCase() }) : '-'}
                                                        `
                                                    }
                                                />
                                            </TableCell>
                                            <TableCell>{item?.code}</TableCell>
                                            <TableCell>{item?.item_name}</TableCell>
                                            <TableCell>{item?.description}</TableCell>
                                            <TableCell align="center">
                                                {`${parseFloat(item?.doc_ori_qty).toFixed(0)} ${item?.uom_name.toUpperCase()}`}
                                            </TableCell>
                                        </TableRow>
                                    )
                                })
                            )
                        })
                    }
                </TableBody>

            </Table>
        </TableContainer>
    )
}

const RenderItemByLocationTable = ({
    t,
    data
}) => {

    if (!data) return <></>

    let pickLocation = []

    Object.keys(data?.pick_locations).forEach((item) => {
        pickLocation.push(
            data?.pick_locations[item]
        )
    })

    return (
        <TableContainer>
            <Table
                size="small"
                stickyHeader
            >
                <TableHead>
                    <TableRow>
                        <TableCell width={20}>#</TableCell>
                        <TableCell width={120}>{t('code')}</TableCell>
                        <TableCell width={350}>{t('itemName')}</TableCell>
                        <TableCell width={200}>{t('Require Qty')}</TableCell>
                        <TableCell>{t('Available Slot')}</TableCell>
                        <TableCell>{t('Qty')}</TableCell>
                    </TableRow>
                </TableHead>

                {
                    pickLocation.map((i, index) => {
                        return(
                            <TableBody key={index}>
                                <TableRow key={i.item_id}>
                                    <TableCell>{(index + 1)}</TableCell>
                                    <TableCell>{i?.code}</TableCell>
                                    <TableCell>{i?.item_name}</TableCell>
                                    <TableCell width={150}>{i?.require_qty}</TableCell>
                                    <TableCell>
                                        <Table
                                            size="small"
                                            stickyHeader
                                        >
                                            <TableBody key={index}>
                                                {
                                                    i.available_slot_uids.map((item, index2) => {
                                                        return(
                                                            <TableRow key={index2}>
                                                                <TableCell width={750}>{item?.rack_slot_lbl}</TableCell>
                                                            </TableRow>
                                                        )
                                                    })
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableCell>
                                    <TableCell>
                                        <Table
                                            size="small"
                                            stickyHeader
                                        >
                                            <TableBody key={index}>
                                                {
                                                    i.available_slot_uids.map((item, index2) => {
                                                        return(
                                                            <TableRow key={index2}>
                                                                <TableCell width={100}>{item?.qty_remain}</TableCell>
                                                            </TableRow>
                                                        )
                                                    })
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        )
                    })
                }
                    
            </Table>
        </TableContainer>
    )
}

const RenderTableFooter = ({
    t,
    data
}) => {

    if (!data) return <></>

    // calculate total qty
    const totalQty = data.docs.reduce((total, i) => total + parseFloat(i.doc_ori_qty), 0)

    return (
        <DocumentViewFooter
            data={data}
            showTax={Boolean(false)}
            showDiscount={Boolean(false)}
            showSubTotal={Boolean(false)}
            showTotalAmount={Boolean(false)}
            customRows={[
                {
                    label : t("totalQty"),
                    display : totalQty
                }
            ]}
        />
    )
}

const RenderDocumentTab = ({
    t,
    data,
    tabValue,
    id,
    navigate,
    getRoute
}) => {

    if(tabValue !== tabName.document) return <></>

    return(
        <Grid container spacing={1} sx={{ mt: 1 }}>
            <Grid item xs={6} sm={6} md={6} display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                <CommonSectionHeader
                    subTitle={t(`detailInformationAboutTheDocumentsInvolved`)}
                />
            </Grid>
            
            <Grid item xs={6} sm={6} md={6} textAlign={"right"}>
                {
                    data?.document?.is_confirm_status === "1" ?
                    (
                        <Chip
                        label={`${t('confirmedAt')} ${data?.document?.is_confirm_date}`}
                        color={"warning"}
                        variant="contained"
                        />
                    )
                    :
                    (
                        <Button
                            type="button"
                            // fullWidth
                            variant="contained"
                            onClick={() => {
                                navigate(getRoute(`documents/pickOrder/update/${id}`))
                            }}
                        >
                            {t('markAsConfirm')}
                        </Button>
                    )
                }
            </Grid>

            <Grid item xs={12} sm={12} md={12} textAlign={"right"}>
                <StyledCard
                    sx={{
                        mt : 1.5,
                        p : 0
                    }}
                >
                    <Grid container rowSpacing={0}>
                        <Grid item md={12}>
                            <RenderDocumentTable
                                t={t}
                                data={data}
                            />
                        </Grid>
                        <Grid item md={12} sx={{mr: 8}}>
                            <RenderTableFooter
                                t={t}
                                data={data}
                            />
                        </Grid>
                    </Grid>
                </StyledCard>
            </Grid>
        </Grid>
    )
}

const RenderItemByDocumentTab = ({
    t,
    data,
    tabValue
}) => {

    if(tabValue !== tabName.itemByDocument ) return <></>
    
    return(
        <Grid container spacing={1} sx={{ mt: 1 }}>
            <Grid item xs={6} sm={6} md={12} display={"flex"} justifyContent={"flex-start"} alignItems={"right"}>
                <CommonSectionHeader
                    subTitle={t(`detailInformationAboutTheDocumentItemsInvolved`)}
                />
            </Grid>

            <Grid item xs={12} sm={12} md={12} textAlign={"right"}>
                <StyledCard
                    sx={{
                        mt : 1.5,
                        p : 0
                    }}
                >
                    <Grid container rowSpacing={0}>
                        <Grid item md={12}>
                            <RenderItemByDocumentTable 
                                t={t}
                                data={data}
                            />
                        </Grid>

                        <Grid item md={12} sx={{mr: 8}}>
                            <RenderTableFooter
                                t={t}
                                data={data}
                            />
                        </Grid>
                    </Grid>
                </StyledCard>
            </Grid>
        </Grid>
    )
}

const RenderPickLocationTab = ({
    t,
    data,
    tabValue
}) => {

    if(tabValue !== tabName.pickLocation ) return <></>
    
    return(
        <Grid container spacing={1} sx={{ mt: 1 }}>
            <Grid item xs={6} sm={6} md={12} display={"flex"} justifyContent={"flex-start"} alignItems={"right"}>
                <CommonSectionHeader
                    subTitle={t(`Detail information about the document item of pick location`)}
                />
            </Grid>

            <Grid item xs={12} sm={12} md={12} textAlign={"right"}>
                <StyledCard
                    sx={{
                        mt : 1.5,
                        p : 0
                    }}
                > 
                    <RenderItemByLocationTable 
                        t={t}
                        data={data}
                    />
                </StyledCard>
            </Grid>
        </Grid>
    )
}

export default function ViewPickOrder({
    routeType
}){
    const { t } = useTranslations({ ns : ["common", "@document"] })

    const { id } = useParams();

    const { setSystemLoading, openCustomDrawer } = useAppContextFeatures();

    const { promptMessage } = useSystemPrompt();
    const { get } = useDocuments({ documentType : documentTypes.pickOrder, targetType : targetTypes.pickOrder });
    const { formatCurrencyDisplay, currencyAbb } = useSystemUtils();
    const { getRoute } = useSystemRoutes(routeType)
    const { getHtmlHead } = useSystemHead(routeType)
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.document.id, scopeTypes.document.pickOrder.id)

    const navigate = useNavigate();
    const [data, setData] = useState()

    const [ tabValue, setTabValue ] = useState(tabName.document);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const fetchData = async () => {

        setSystemLoading(true);

        try {

            let response = await get({ id, dataTypesArray : ["dependency", "adjustment", "pick_location"] });
            // console.log('response?.data?.items', response?.data)
            setData(response?.data)

        } catch (error) {
            promptMessage(false, `${error.message}`)
        }

        setSystemLoading(false)

    }

    useEffect(() => {

        fetchData();

    }, [])

    const getBreadcumbActionMenus = () => {

        let props = []

        if (isPermissionAllow({ functionType : functionTypes.pageUpdate.id })) {
            props.push({
                displayText : t("editDocument"),
                href : getRoute(`documents/pickOrder/update/${id}`)
            })
        }

        if (isPermissionAllow({ functionType : functionTypes.pageView.id })) {

            props.push({
                displayText : t("printPreview"),
                onClick : () => {

                    // adding the qrcode into doc data
                    data.qrCodeData = getQrCodeDataUrl()

                    openCustomDrawer({
                        show : true,
                        anchor : "right",
                        title : `Preview PDF`,
                        PaperProps : {
                            sx : { width : 2 / 3 }
                        },
                        // handleOnClose: () => setPreviewPdfOpen(false),
                        ComponentActions : <></>,
                        ComponentBody :
                            <CommonPdf
                                routeType={routeType}
                                renderMode={renderModes.preview.id}
                                documentType={commonPdfDocumentTypes.pickOrder.id}
                                document={{
                                    title : data?.document?.doc_number
                                }}
                                data={data}
                                // customData={{
                                //     items: data
                                // }}
                            />
                    })

                    return true;

                }
            })

        }

        return props

    }

    const RenderFormProfile = () => {
        return (
            <StyledCard>
                <Grid container spacing={0.5}>
                    <Grid item xs={6} sm={6} md={6} textAlign={"left"}>

                        <CommonSectionHeader
                            title={t(`profile`)}
                            subTitle={t(`relatedProfilesAttachedToDocument`)}
                        />

                    </Grid>

                    <Grid item xs={12}>
                        <StyledDivider/>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} sx={{ mt : 2 }}>
                        <Grid container spacing={0.5}>

                            <Grid item xs={12} sm={12} md={3} textAlign={"left"}>
                                <StyledLabel>{t('location')}</StyledLabel>
                            </Grid>

                            <Grid item xs={12} sm={12} md={9} textAlign={"left"}>
                                <StyledContent>
                                    {data?.document?.location_name}
                                </StyledContent>
                                <StyledContent2>
                                    {data?.document?.state_name}
                                </StyledContent2>
                            </Grid>

                            {/* <Grid item xs={12} sm={12} md={3} textAlign={"left"}>
                                <StyledLabel>{t('logistic')}</StyledLabel>
                            </Grid>

                            <Grid item xs={12} sm={12} md={9} textAlign={"left"}>
                                <StyledContent>
                                    {data?.document?.logistic_label}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={3} textAlign={"left"}>
                                <StyledLabel>{t('driver')}</StyledLabel>
                            </Grid>

                            <Grid item xs={12} sm={12} md={9} textAlign={"left"}>
                                <StyledContent>
                                    {data?.document?.driver_name}
                                </StyledContent>
                            </Grid> */}

                        </Grid>
                    </Grid>

                </Grid>
            </StyledCard>
        )
    }

    const RenderFormDocument = () => {
        return (
            <StyledCard>
                <Grid container spacing={0.5}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={t(`document`)}
                            subTitle={t(`basicInformationAboutTheDocument`)}
                        />

                    </Grid>
                    <Grid item xs={12}>
                        <StyledDivider/>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} sx={{ mt : 2 }}>
                        <Grid container spacing={0.5}>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>{t('documentNo')}</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {data?.document.doc_number}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>{t('documentDate')}</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {data?.document.doc_date}
                                </StyledContent>
                            </Grid>

                            {/* <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>Approval Status</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {data?.document.approve_status === "1"? 'Approved' : 'Pending'}
                                </StyledContent>
                            </Grid> */}

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>
                                    {t('confirm')}
                                </StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {data?.document.is_confirm_status === "1" ? "Yes" : "-"}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>
                                    {t('remark')}
                                </StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {data?.document.doc_remark}
                                </StyledContent>
                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>
            </StyledCard>
        )
    }

    const RenderFormDependency = () => {
        return (
            <ViewDocumentDependency
                routeType={routeType}
                data={data?.document}
            />
        )
    }

    const RenderTabInfo = () => {
        return(
            <>
                <Box sx={{ width: '100%', typography: 'body1' }}>
                    <TabContext value={tabValue}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs 
                                variant="fullWidth"
                                value={tabValue}
                                centered
                                onChange={handleTabChange} 
                            >
                                <Tab label={t('document')} value={tabName.document} />
                                <Tab label={t('Item By Document')} value={tabName.itemByDocument} />
                                <Tab label={t('Item By Location')} value={tabName.pickLocation} />
                            </Tabs>
                        </Box>

                        {/* <TabPanel value="document">
                            <RenderDocumentTab />
                        </TabPanel> */}

                        {/* <TabPanel value="item">
                            <RenderItemTab />
                        </TabPanel> */}

                    </TabContext>
                </Box> 
            </>
        )
    }

    const RenderForm = () => {
        return (
            <>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={5} textAlign={"left"}>
                        {
                            RenderFormDocument()
                        }
                    </Grid>
                    <Grid item xs={12} sm={12} md={7} textAlign={"left"}>
                        {
                            RenderFormProfile()
                        }
                        {
                            RenderFormDependency()
                        }
                    </Grid>
                </Grid>

                <Grid container spacing={0} sx={{ px : 1, mt : 3 }}>
                    <RenderTabInfo />

                    <RenderDocumentTab 
                        t={t}
                        data={data}
                        tabValue={tabValue}
                        id={id}
                        navigate={navigate}
                        getRoute={getRoute}
                    />

                    <RenderItemByDocumentTab 
                        t={t}
                        data={data}
                        tabValue={tabValue}
                    />

                    <RenderPickLocationTab 
                        t={t}
                        data={data}
                        tabValue={tabValue}
                    />
                </Grid>

                {/* <Grid container spacing={1} sx={{ pl: 2, pr: 2}}>
                    <Grid item md={12} textAlign={"center"}>
                        <Button
                            type="button"
                            // fullWidth
                            variant="contained"
                            sx={{ 
                                mt: 3,
                                mb: 2
                            }}
                            // loading={isLoading}
                            onClick={() => navigate(-1)}
                        >
                            Back
                        </Button>
                    </Grid>
                </Grid> */}
            </>
        )
    }

    return (
        <Box>
            {
                getHtmlHead({ routeType, title : headTitles.viewPickOrder })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={`${t('pickOrders')} ${data?.document.doc_number}`}
                actionMenus={
                    getBreadcumbActionMenus()
                }
                breadcrumbs={[
                    {
                        displayText : t("pickOrders"),
                        props : {
                            href : getRoute("documents/pickOrders")
                        }
                    },
                    {
                        displayText : `#${data?.document.doc_number}`,
                        props : {
                            color : 'secondary.main',
                        }
                    },
                ]}
            />

            {
                isPermissionAllow({ functionType : functionTypes.pageView.id }) ?
                    RenderForm()
                    :
                    (
                        <CommonRestricted/>
                    )
            }

            {
                DocumentQrCode({
                    data,
                    outputType : scanDataOutputTypes.qrcode,
                    scopeType : scanDataScopeTypes.document,
                    targetType : scanDataTargetTypes.document.salesOrder
                })
            }

        </Box>
    )
}